"use client";

import { Content, Portal, Root } from "@radix-ui/react-dialog";
import * as Form from "@radix-ui/react-form";
import clsx from "clsx";
import { useState } from "react";

import SearchIcon from "@/assets/svg/SearchIcon";

import useSearchModal from "../useSearchModal";
import styles from "./search-component.module.css";

const SearchComponent = () => {
  const { isOpen, input, onSubmit, setInput, closeModal } = useSearchModal();
  const [container, setContainer] = useState<
    HTMLDivElement | HTMLBodyElement | null
  >(null);
  return (
    <nav
      style={{
        display: isOpen ? "block" : "none",
        position: "absolute",
        inset: "0px",
      }}
    >
      <Root>
        <Portal forceMount={isOpen ? true : undefined} container={container}>
          <Content
            asChild
            onPointerDownOutside={closeModal}
            onEscapeKeyDown={closeModal}
          >
            <div className={styles.wrapper} data-layout={"scroll-modal"}>
              <div className={styles["search-bar"]} data-layout="page">
                <Form.Root
                  className={clsx(styles["search-form"])}
                  onSubmit={(e) => onSubmit(e)}
                >
                  <Form.Field name="search">
                    <Form.Label>
                      <div
                        className={clsx(
                          styles["search-label"],
                          input.length > 0 ? styles.active : "",
                        )}
                      >
                        {"Søk"}
                      </div>
                    </Form.Label>
                    <Form.Control asChild>
                      <input
                        type="text"
                        className={clsx(input.length > 0 ? styles.active : "")}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Submit asChild>
                    <button type="submit">
                      <SearchIcon size="large" />
                    </button>
                  </Form.Submit>
                </Form.Root>
              </div>
            </div>
          </Content>
        </Portal>
      </Root>
      <div ref={setContainer} />
    </nav>
  );
};

export default SearchComponent;
